// extracted by mini-css-extract-plugin
export default {"content":"BI-z","lookName":"CI-z","shopTheLookContainer":"DI-z","productContainer":"EI-z","imageContainer":"FI-z","mainImage":"GI-z"};